import { onCheckCondition } from 'designer/component/action/condition/Action'
import { hasRules, onCheckRules } from 'designer/component/rules/Action'

export const checkRulesOrCondition = (
  designContext,
  formData = null,
  uiKey = null,
  status = {},
) => {
  let { jsonForm } = designContext

  if (hasRules(jsonForm)) {
    formData = onCheckRules(designContext, formData, uiKey, {
      ...status,
      isDefaultLoad: true,
    })
  }

  onCheckCondition(designContext, formData, uiKey, status)
  return formData
}
